import { render } from "./ParagraphItem.vue?vue&type=template&id=d91fd0b4&scoped=true"
import script from "./ParagraphItem.vue?vue&type=script&lang=js"
export * from "./ParagraphItem.vue?vue&type=script&lang=js"

import "./ParagraphItem.vue?vue&type=style&index=0&id=d91fd0b4&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d91fd0b4"]])

export default __exports__